import CountryList from '../../slices/master/country/CountryList'
import CountryDetails from "../../slices/master/country/CountryDetails"
import StateList from '../../slices/master/state/StateList'
import StateDetails from '../../slices/master/state/StateDetails'
import StatebyCountry from '../../slices/master/state/StatebyCountry'
import DistrictList from '../../slices/master/district/DistrictList'
import DistrictDetails from '../../slices/master/district/DistrictDetails'
import DistrictbyState from '../../slices/master/district/DistrictbyState'
import TehsilList from '../../slices/master/tehsil/TehsilList'
import TehsilDetails from '../../slices/master/tehsil/TehsilDetails'
import TehsilbyDistrict from '../../slices/master/tehsil/TehsilbyDistrict'
import CityList from '../../slices/master/city/CityList'
import CityDetails from '../../slices/master/city/CityDetails'
import CitybyState from '../../slices/master/city/CitybyState'
import CategoryList from '../../slices/master/category/CategoryList'
import CategoryDetails from '../../slices/master/category/CategoryDetails'
import SubCategoryList from '../../slices/master/sub_category/SubCategoryList'
import SubCategoryDetails from '../../slices/master/sub_category/SubCategoryDetails'
import SubCategorybyCategory from '../../slices/master/sub_category/SubCategorybyCategory'
import ServiceList from '../../slices/master/service/ServiceList'
import ServiceDetails from '../../slices/master/service/ServiceDetails'
import ServicebyCategory from '../../slices/master/service/ServicebyCategory'
import PlanList from '../../slices/master/plan/PlanList'
import PlanDetails from '../../slices/master/plan/PlanDetails'
import DesignationList from '../../slices/master/designation/DesignationList'
import DesignationDetails from '../../slices/master/designation/DesignationDetails'
import ExpenseCategoryList from '../../slices/master/expenseCategory/ExpenseCategoryList'
import ExpenseCategoryDetails from '../../slices/master/expenseCategory/ExpenseCategoryDetails'

const masterReducer = {
    countryList: CountryList,
    countryDetails: CountryDetails,
    stateList: StateList,
    stateDetails: StateDetails,
    statebyCountry: StatebyCountry,
    districtList: DistrictList,
    districtDetails: DistrictDetails,
    districtbyState: DistrictbyState,
    tehsilList: TehsilList,
    tehsilDetails: TehsilDetails,
    tehsilbyDistrict: TehsilbyDistrict,
    cityList: CityList,
    cityDetails: CityDetails,
    citybyState: CitybyState,
    categoryList: CategoryList,
    categoryDetails: CategoryDetails,
    subCategoryList: SubCategoryList,
    subCategoryDetails: SubCategoryDetails,
    subCategorybyCategory: SubCategorybyCategory,
    serviceList: ServiceList,
    serviceDetails: ServiceDetails,
    servicebyCategory: ServicebyCategory,
    planList: PlanList,
    planDetails: PlanDetails,
    designationList: DesignationList,
    designationDetails: DesignationDetails,
    expenseCategoryList : ExpenseCategoryList,
    expenseCategoryDetails : ExpenseCategoryDetails,
};

export default masterReducer;